
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/limited-offer",
      function () {
        return require("private-next-pages/limited-offer.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/limited-offer"])
      });
    }
  